export enum ToastTypes {
	Error = 'error',
	Success = 'success',
	Warning = 'warning',
}

export enum ToastVisualStates {
	Disabled = '',
	Enabled = 'enabled',
	Expired = 'expired',
	Closed = 'closed',
}

export enum CloseOrigin {
	LIFETIME_FOCUS_HAS_LEFT = 'lifetime-focus-has-left-the-toaster',
	LIFETIME_FOCUS_REMAINED = 'lifetime-focus-remained-on-toaster',
	MANUAL = 'manual',
	CTA_CALLBACK = 'cta-callback',
}

export type ToastData = {
	type: ToastTypes;
	label: string | React.ReactElement;
	ariaLabel: string;
	closeButtonAriaLabel: string;
	ctaLabel?: string;
	ctaCallback?: (callback: () => void) => void;
	ctaAriaLabel?: string;
	ctaDataLinkEvent?: string;
	onClose?: (x: CloseOrigin) => void;
	lifetime?: number;
	focused?: boolean;
	focusNext?: () => void;
	focusPrev?: () => void;
};
